/* Turn "ships in 5–8 weeks" into "arrives between 7 Sep and 28 Sep" (Wedance, 2026-08).

   WHY: a concrete delivery date on the product page is one of the better-evidenced conversion
   levers (Forrester puts it at 13–25%), and "delivery too slow" is the #3 cause of cart
   abandonment — but only when the date is real rather than a generic range. Our customers buy for
   a specific event ("will these arrive before the comp on the 20th?"), and a week count makes them
   do the arithmetic. A RANGE rather than a single date is deliberate: the spread genuinely is
   5–8 weeks, and inventing a single date would be false precision on a made-to-order shoe.

   WHY JS AND NOT LIQUID: Shopify caches product renders, so a Liquid-computed date can be served
   days stale — and a date in the past is worse than no date. The weeks text ships from Liquid as
   the no-JS fallback and is replaced here at view time.

   Markup contract: <span data-lead-range="5–8" data-lead-locale="en">ships in 5–8 weeks</span> */
(function () {
  function fmt(d, locale) {
    try {
      return d.toLocaleDateString(locale === 'fr' ? 'fr-CA' : 'en-CA', { day: 'numeric', month: 'short' });
    } catch (e) {
      return d.getDate() + '/' + (d.getMonth() + 1);
    }
  }

  function run() {
    document.querySelectorAll('[data-lead-range]').forEach(function (el) {
      var raw = (el.getAttribute('data-lead-range') || '').replace(/[–—]/g, '-');
      var m = raw.match(/(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)/);
      var one = !m && raw.match(/^\s*(\d+(?:\.\d+)?)\s*$/);
      if (one) {
        /* A single figure (owner lead times, 2026-10): "ships by <date>" = today + N weeks, the SAME
           formula as the availability_date sent to Google, so page and feed state one date. */
        var n = parseFloat(one[1]);
        if (!(n > 0)) return;
        /* Toronto's calendar day, not the visitor's: the feed's availability_date is Toronto midnight + N
           weeks, and a crawler in another zone near midnight would otherwise read a date a day off. */
        var ymd;
        try {
          ymd = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto', year: 'numeric', month: '2-digit', day: '2-digit' })
            .format(new Date()).split('-').map(Number);
        } catch (e) {
          var t = new Date(); ymd = [t.getFullYear(), t.getMonth() + 1, t.getDate()];
        }
        var by = new Date(Date.UTC(ymd[0], ymd[1] - 1, ymd[2] + n * 7, 12));
        var loc1 = el.getAttribute('data-lead-locale') || 'en';
        var opts = { day: 'numeric', month: 'short', timeZone: 'UTC' };
        var txt;
        try { txt = by.toLocaleDateString(loc1 === 'fr' ? 'fr-CA' : 'en-CA', opts); } catch (e) { txt = fmt(by, loc1); }
        el.textContent = loc1 === 'fr' ? "expédition d'ici le " + txt : 'ships by ' + txt;
        return;
      }
      if (!m) return; // unparseable — leave the Liquid text alone
      var lo = parseFloat(m[1]),
        hi = parseFloat(m[2]);
      if (!(lo > 0) || !(hi >= lo)) return;
      var locale = el.getAttribute('data-lead-locale') || 'en';
      var now = new Date();
      var a = new Date(now.getTime() + lo * 7 * 86400000);
      var b = new Date(now.getTime() + hi * 7 * 86400000);
      /* This replaces the span's ENTIRE textContent, so the span must contain only the clause —
         the "Special order —" / "Made to order —" label lives outside it in Liquid. The text is a
         mid-sentence clause and stays lowercase by design; it must never read as a sentence start.

         "ships", not "arrives": the underlying figure is custom.special_order_lead_time, which the
         Liquid fallback states as "ships in 5–8 weeks". Rendering it as an arrival date would
         promise a delivery window we haven't actually measured. */
      el.textContent =
        locale === 'fr'
          ? 'expédition entre le ' + fmt(a, 'fr') + ' et le ' + fmt(b, 'fr')
          : 'ships between ' + fmt(a, 'en') + ' and ' + fmt(b, 'en');
    });
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      setTimeout(run, 60);
    });
  }
})();
